// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1W15k","label":"Category_label__3OxBH","content":"Category_content__uEl3P","header":"Category_header__2_O7l","location":"Category_location__1XoWX"};